import React from "react";
import "./css/Stemp.css";
export default function Stemp(props)
{
    return (
        <div className="stemplate">
            <img src={props.image} alt={props.alt}/>
        </div>
    )
}